import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Responsive, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import './ResetButton.scss';

const ResetButton = ({ onClick }) => {

    return window.location.pathname !== '/' && (
        <Fragment>
            <Responsive maxWidth={768} className="pi-reset">
                <Button className="reset-btn" icon="cancel" onClick={onClick} />
            </Responsive>
            <Responsive minWidth={769} className="pi-reset">
                <Button className="reset-btn" icon labelPosition='left' onClick={onClick}>
                    <Icon name='repeat' />
                    {i18next.t('order.abortOrder')}
                </Button>
            </Responsive>
        </Fragment>
    );
};

ResetButton.propTypes = {
    onClick: PropTypes.func
};

export default ResetButton;
